const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'needInvoice',
      label: 'Czy potrzebuję faktury?',
      column: 1,
      type: 'boolean',
      mandatory: true,
      defaultValue: false
    },
    {
      name: 'invoiceName',
      label: 'Nazwa nabywcy do faktury',
      column: 1,
      type: 'textarea',
      conditionalOn: 'needInvoice',
      preserveOnHide: true
    },
    {
      name: 'invoiceNip',
      label: 'NIP',
      column: 1,
      conditionalOn: 'needInvoice',
      preserveOnHide: true
    },
    {
      name: 'invoiceAddress',
      label: 'Adres do faktury',
      column: 1,
      type: 'textarea',
      rows: 3,
      conditionalOn: 'needInvoice',
      preserveOnHide: true
    }
  ]
};

export default fields;
